module.exports = __webpack_public_path__ + "img/colse_new.f3a0c732.svg";